import { closeIcon } from "assets/images";
import { Button, GroupInput, Input, Label } from "common/components";
import React, { useState } from "react";

function AddExperienceModal(props) {
  const { setShow, show, data, setData } = props;
  let [fieldValues, setFieldValue] = useState({});
  let [errors, setErrors] = useState({});
  let tmpData = [];
  if (data) {
    tmpData = structuredClone(data);
  }

  const handleChange = (e, key, file) => {
    let data;

    if (file) {
      data = e.target.files[0];
    } else {
      data = e.target.value;
    }

    fieldValues[key] = data;
    setFieldValue({ ...fieldValues });
  };

  const handleSave = () => {
    let errors = {};
    if (!fieldValues.companyname) {
      errors.companyname = "This field is required";
    }
    if (!fieldValues.start_date) {
      errors.start_date = "This field is required";
    }
    if (!fieldValues.end_date) {
      errors.end_date = "This field is required";
    }
    if (!fieldValues.payslip) {
      errors.payslip = "This field is required";
    }

    if (!fieldValues.offerletter) {
      errors.offerletter = "This field is required";
    }
    if (!fieldValues.relievingletter) {
      errors.relievingletter = "This field is required";
    }
    if (!fieldValues.resignationletter) {
      errors.resignationletter = "This field is required";
    }
    if (!fieldValues.compensation) {
      errors.compensation = "This field is required";
    }
    if (!fieldValues.experienceletter) {
      errors.experienceletter = "This field is required";
    }

    if (Object.keys(errors).length) {
      setErrors({ ...errors });
      return;
    }

    if (tmpData.length > 0) {
      tmpData.push(fieldValues);
    } else {
      tmpData = [fieldValues];
    }
    setData(tmpData);
    setShow(false);
  };

  return (
    <div className="d-flex align-items-center justify-content-center mb-4 ">
      <div className="relative pt-4 bordermodal">
        <div
          className="closeIcon"
          onClick={() => {
            setShow(false);
          }}
        >
          <img src={closeIcon} />
        </div>
        <div className="px-4 pt-4">
          <Label label="Company Name" />
          <Input
            required
            type="text"
            value={fieldValues.companyname || ""}
            onChange={(e) => {
              handleChange(e, "companyname");
            }}
            touched={true}
            error={errors.companyname}
          />
          <div className="twoboxes mt-4">
            <div>
              <Label label="Start Date" />
              <Input
                required
                type="date"
                value={fieldValues.start_date || ""}
                onChange={(e) => {
                  handleChange(e, "start_date");
                }}
                touched={true}
                error={errors.start_date}
              />
            </div>
            <div>
              <Label label="End Date" />
              <Input
                required
                type="date"
                value={fieldValues.end_date || ""}
                onChange={(e) => {
                  handleChange(e, "end_date");
                }}
                touched={true}
                error={errors.end_date}
              />
            </div>

            <div>
              <Label label="Payslip" />
              <Input
                accept="image/*, .pdf"
                type="file"
                required
                // value={""}
                onChange={(e) => {
                  handleChange(e, "payslip", true);
                }}
                touched={true}
                error={errors.payslip}
              />
            </div>
            <div>
              <Label label="Offer Letter" />
              <Input
                accept="image/*, .pdf"
                type="file"
                required
                onChange={(e) => {
                  handleChange(e, "offerletter", true);
                }}
                touched={true}
                error={errors.offerletter}
              />
            </div>
            <div>
              <Label label="Relieving Letter" />
              <Input
                accept="image/*, .pdf"
                type="file"
                required
                onChange={(e) => {
                  handleChange(e, "relievingletter", true);
                }}
                touched={true}
                error={errors.relievingletter}
              />
            </div>
            <div>
              <Label label="Resignation Letter" />
              <Input
                accept="image/*, .pdf"
                type="file"
                required
                onChange={(e) => {
                  handleChange(e, "resignationletter", true);
                }}
                touched={true}
                error={errors.resignationletter}
              />
            </div>
            <div>
              <Label label="Compensation" />
              <Input
                label="Compensation"
                accept="image/*, .pdf"
                type="file"
                required
                onChange={(e) => {
                  handleChange(e, "compensation", true);
                }}
                touched={true}
                error={errors.compensation}
              />
            </div>
            <div>
              <Label label="Experience Letter" />
              <Input
                accept="image/*, .pdf"
                type="file"
                required
                onChange={(e) => {
                  handleChange(e, "experienceletter", true);
                }}
                touched={true}
                error={errors.experienceletter}
              />
            </div>
          </div>
          <div className="d-flex justify-content-end pt-4">
            <Button onClick={handleSave} type="button" label="Save" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddExperienceModal;
